import { render, staticRenderFns } from "./CriminalFileView.vue?vue&type=template&id=022888cb&"
import script from "./CriminalFileView.vue?vue&type=script&lang=js&"
export * from "./CriminalFileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports